import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "numbered-expansion-item-header" }
const _hoisted_2 = { class: "number" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "dash number" }, " /", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showCurrentSlidesWithTranslation(), (item, index) => {
      return (_openBlock(), _createBlock(_component_q_list, {
        key: index,
        class: "expansion"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_expansion_item, {
            "expand-icon-class": "icon",
            "no-ripple": "",
            label: item.title,
            "dense-toggle": ""
          }, _createSlots({
            default: _withCtx(() => [
              _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_card_section, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.text), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, [
            (item.numbered)
              ? {
                  name: "header",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.displayLeadingZero(index)), 1),
                      _hoisted_3,
                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                    ])
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["label"])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}